import {
  basketOptimizerOptimizeCanceled,
  basketOptimizerOptimizeRequested,
} from 'state/advisory/basket-optimizer/actions';
import { getCurrentOptimizeId, isBasketOptimizerProcessing } from 'state/advisory/basket-optimizer/selectors';
import type { Thunk } from 'state/state.common';
export function basketOptimizerOptimizeRequestedThunk(
  tabId: string,
  productType: string,
  underlyingsCount: number,
): Thunk<void> {
  return (dispatch, getState, { selectors: { getStaticFormQuoteId } }) => {
    const state = getState();

    const quoteId = getStaticFormQuoteId(state, tabId);

    if (quoteId === undefined) {
      return;
    }

    dispatch(basketOptimizerOptimizeRequested(tabId, quoteId, productType, underlyingsCount));
  };
}

export function basketOptimizerOptimizeCanceledThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();

    const optimizeId = getCurrentOptimizeId(state, tabId);

    if (optimizeId === undefined || isBasketOptimizerProcessing(state, tabId) === false) {
      return;
    }

    dispatch(basketOptimizerOptimizeCanceled(tabId, optimizeId));
  };
}
